export const ZENDESK_SNIPPET_ID = 'ze-snippet';
export const ZENDESK_SNIPPET_URL =
	'https://static.zdassets.com/ekr/snippet.js?key=b2f7e686-e618-409f-bc7b-0ca9fb77e040';

export enum EHelpButtonArticles {
	EM_USERS = 'EM Users',
	EM_PAGE_ACTION_BUTTONS = 'EM Page Action Buttons',
	CUSTOMER_STORES = 'Customer Stores',
	COMMENTS = 'Comments',
}

export const HELP_CENTER_ARTICLES = {
	[EHelpButtonArticles.EM_USERS]: 5113010314655,
	[EHelpButtonArticles.EM_PAGE_ACTION_BUTTONS]: 5112933775391,
	[EHelpButtonArticles.CUSTOMER_STORES]: 5112827116959,
	[EHelpButtonArticles.COMMENTS]: 5112790090783,
};

export const HELP_CENTER_ARTICLE_URLS = {
	[EHelpButtonArticles.EM_USERS]:
		'https://help.easproject.com/hc/en-gb/articles/5113010314655-How-to-manage-EM-users',
	[EHelpButtonArticles.EM_PAGE_ACTION_BUTTONS]:
		'https://help.easproject.com/hc/en-gb/articles/5112933775391-EM-page-action-buttons-descriton',
	[EHelpButtonArticles.CUSTOMER_STORES]:
		'https://help.easproject.com/hc/en-gb/articles/5112827116959-How-to-manage-Customer-s-Stores',
	[EHelpButtonArticles.COMMENTS]:
		'https://help.easproject.com/hc/en-gb/articles/5112790090783-How-the-Comments-Feature-Works',
};
